import React, { useState, useEffect, useCallback } from 'react';
import { useTheme } from "@material-ui/core/styles";
import { useHistory } from 'react-router-dom';
import AdminLayout from '../../layouts/AdminLayout';
import Pagination from '../../components/Pagination';
import ConfirmDialog from '../../components/ConfirmDialog';
import { getHadithById, deleteHadith, reorderHadith, getHadithCategories, getHadithBooks, getHadiths } from '../../services/hadithService';
import {
  Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Button, IconButton, Chip, TextField, MenuItem, Box, makeStyles, CircularProgress, Snackbar, Tooltip, Typography, Select, FormControl, InputLabel
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import AddIcon from '@material-ui/icons/Add';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import HadithSyncDialog from '../../components/hadith/HadithSyncDialog';
import HadithFormModal from './HadithFormModal';

// Removed hardcoded book list; books are fetched from Firestore

const useStyles = makeStyles((theme) => ({
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(3),
    flexWrap: 'wrap',
    gap: theme.spacing(2),
  },
  filterRow: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  filterField: {
    minWidth: 180,
    '& .MuiInputBase-root': {
      
    },
  },
  categorySelect: {
    minWidth: 200,
    '& .MuiInputLabel-root': {
      color: theme.palette.text.secondary,
      fontSize: '0.85rem',
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: '#10b981',
    },
    '& .MuiOutlinedInput-root': {
      
      borderRadius: 8,
      color: theme.palette.text.primary,
      height: 40,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.divider,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.divider,
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#10b981',
    },
    '& .MuiSelect-icon': { color: theme.palette.text.secondary },
    '& .MuiSelect-select': { paddingTop: 10, paddingBottom: 10 },
  },
  categoryChip: {
    backgroundColor: 'rgba(16,185,129,0.12)',
    color: '#10b981',
    border: '1px solid rgba(16,185,129,0.25)',
    fontWeight: 600,
    fontSize: '0.72rem',
    height: 22,
  },

  tableContainer: {
    borderRadius: 16,
    boxShadow: '0 4px 24px rgba(0,0,0,0.2)',
    overflow: 'hidden',
    border: `1px solid ${theme.palette.divider}`,
  },
  statusPublished: {
    backgroundColor: 'rgba(16,185,129,0.15)',
    color: '#10b981',
    border: '1px solid rgba(16,185,129,0.3)',
    fontWeight: 600,
  },
  statusDraft: {
    backgroundColor: 'rgba(245,158,11,0.15)',
    color: '#f59e0b',
    border: '1px solid rgba(245,158,11,0.3)',
    fontWeight: 600,
  },
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 400,
    background: theme.palette.background.paper,
    borderRadius: 16,
    border: `1px solid ${theme.palette.divider}`,
  },
  loadingText: {
    marginTop: 16,
    color: theme.palette.text.secondary,
    fontWeight: 500,
  },
  actionBtn: {
    color: theme.palette.text.secondary,
    padding: 8,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      color: theme.palette.text.primary,
    },
  },
  deleteBtn: {
    color: theme.palette.text.secondary,
    padding: 8,
    '&:hover': {
      backgroundColor: 'rgba(239,68,68,0.1)',
      color: '#ef4444',
    },
  },
  orderBadge: {
    background: theme.palette.action.hover,
    color: theme.palette.text.secondary,
    padding: '4px 8px',
    borderRadius: 6,
    fontWeight: 600,
    fontSize: '0.8rem',
  },
  countChip: {
    background: 'linear-gradient(135deg, rgba(16,185,129,0.15) 0%, rgba(5,150,105,0.15) 100%)',
    color: '#10b981',
    border: '1px solid rgba(16,185,129,0.3)',
    fontWeight: 700,
    fontSize: '0.85rem',
    height: 36,
    padding: '0 8px',
    borderRadius: 10,
  },
}));

export default function HadithListPage() {
  const classes = useStyles();
  
  const theme = useTheme();
const history = useHistory();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [filter, setFilter] = useState('all');
  const [category, setCategory] = useState('all');
  const [bookFilter, setBookFilter] = useState('all');
  const [idFilter, setIdFilter] = useState('');
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: '' });
  const [books, setBooks] = useState([]);
  const [categories, setCategories] = useState([]);
  const [syncDialogOpen, setSyncDialogOpen] = useState(false);
  const [formModalOpen, setFormModalOpen] = useState(false);
  const [selectedHadithId, setSelectedHadithId] = useState(null);

  const handleOpenCreateModal = () => {
    setSelectedHadithId(null);
    setFormModalOpen(true);
  };

  const handleOpenEditModal = (hadithId) => {
    setSelectedHadithId(hadithId);
    setFormModalOpen(true);
  };

  const handleCloseFormModal = () => {
    setFormModalOpen(false);
    setSelectedHadithId(null);
  };

  const handleFormSuccess = () => {
    setSnackbar({
      open: true,
      message: selectedHadithId ? 'হাদিস সফলভাবে আপডেট করা হয়েছে!' : 'নতুন হাদিস সফলভাবে তৈরি করা হয়েছে!',
    });
    loadData({ page });
  };

  useEffect(() => {
    let mounted = true;
    // Fetch books (including custom ones)
    getHadithBooks().then((dbBooks) => {
      if (mounted) {
        setBooks(dbBooks);
      }
    });
    // Fetch categories
    getHadithCategories().then((cats) => {
      if (mounted) {
        setCategories(cats);
      }
    });
    return () => { mounted = false; };
  }, []);

  const getBookName = useCallback((sourceId) => {
    const book = books.find((b) => b.id === sourceId);
    if (!book) return sourceId || 'Unknown';
    const nameEn = book.nameEn || book.name;
    const nameBn = book.nameBn || '';
    return `${nameEn}${nameBn ? ` (${nameBn})` : ''}`;
  }, [books]);

  // Get category name (English + Bangla if available)
  const getCategoryName = useCallback((catId) => {
    const cat = categories.find((c) => c.id === catId);
    if (!cat) return catId || 'Unknown';
    return `${cat.nameEn || cat.name} ${cat.nameBn ? `(${cat.nameBn})` : ''}`;
  }, [categories]);

  const loadData = useCallback(async (opts = {}) => {
    setLoading(true);
    const targetPage = opts.page !== undefined ? opts.page : 1;
    try {
      if (idFilter) {
        const doc = await getHadithById(idFilter);
        setItems(doc ? [doc] : []);
        setTotalCount(doc ? 1 : 0);
        setTotalPages(1);
        setPage(1);
      } else {
        const result = await getHadiths({
          page: targetPage,
          filter,
          category,
          book: bookFilter,
        });
        setItems(result.items);
        setTotalCount(result.total);
        setTotalPages(result.totalPages);
        setPage(result.page);
      }
    } catch (err) {
      console.error('Firestore error:', err);
      const message = err?.message || 'Failed to load hadiths';
      setSnackbar({ open: true, message });
    }
    setLoading(false);
  }, [filter, category, bookFilter, idFilter]);

  useEffect(() => {
    loadData({ page: 1 });
  }, [filter, category, bookFilter, idFilter]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
    loadData({ page: newPage });
  };

  const handleDelete = async () => {
    if (!deleteTarget) return;
    try {
      await deleteHadith(deleteTarget.id);
      setSnackbar({ open: true, message: 'Hadith removed successfully' });
      setDeleteTarget(null);
      loadData();
    } catch (err) {
    console.error('Error loading hadiths:', err);
    const message = err?.message || 'Failed to load hadiths';
    setSnackbar({ open: true, message });
  }
  };

  const handleReorder = async (item, direction) => {
    const idx = items.indexOf(item);
    const targetIdx = direction === 'up' ? idx - 1 : idx + 1;
    if (targetIdx < 0 || targetIdx >= items.length) return;
    const target = items[targetIdx];
    const tempOrder = item.orderIndex;
    try {
      await Promise.all([
        reorderHadith(item.id, target.orderIndex),
        reorderHadith(target.id, tempOrder),
      ]);
      loadData();
    } catch (err) {
      setSnackbar({ open: true, message: 'Failed to reorder' });
    }
  };

  return (
    <AdminLayout title="Hadith Repository">
      <div className={classes.toolbar}>
        <div className={classes.filterRow}>
          <TextField
            select
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            className={classes.filterField}
            variant="outlined"
            size="small"
            InputProps={{
              startAdornment: <Box component="span" pr={1} color="#64748b" fontSize="0.85rem" fontWeight={600}>STATUS:</Box>
            }}
          >
            <MenuItem value="all">All Records</MenuItem>
            <MenuItem value="published">Published Only</MenuItem>
            <MenuItem value="draft">Drafts Only</MenuItem>
          </TextField>

            {/* Book Filter */}
            <FormControl variant="outlined" className={classes.categorySelect}>
              <InputLabel id="book-filter-label">Book</InputLabel>
              <Select
                labelId="book-filter-label"
                value={bookFilter}
                onChange={(e) => setBookFilter(e.target.value)}
                label="Book"
                MenuProps={{
                  getContentAnchorEl: null,
                  anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                  transformOrigin: { vertical: 'top', horizontal: 'left' },
                  PaperProps: {
                    style: {
                      border: `1px solid ${theme.palette.divider}`,
                      borderRadius: 10,
                    },
                  },
                }}
              >
                <MenuItem value="all">All Books</MenuItem>
                {books.map((book) => (
                  <MenuItem key={book.id} value={book.id}>
                    {book.nameEn || book.name}{book.nameBn ? ` (${book.nameBn})` : ''}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Category Filter */}
            <FormControl variant="outlined" className={classes.categorySelect}>
                <InputLabel id="category-filter-label">Hadith Category</InputLabel>
              <Select
                labelId="category-filter-label"
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                label="Category"
                MenuProps={{
                  getContentAnchorEl: null,
                  anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                  transformOrigin: { vertical: 'top', horizontal: 'left' },
                  PaperProps: {
                    style: {
                      border: `1px solid ${theme.palette.divider}`,
                      borderRadius: 10,
                    },
                  },
                }}
              >
                <MenuItem value="all">All Categories</MenuItem>
                {categories.map((cat) => (
                  <MenuItem key={cat.id} value={cat.id}>
                    {cat.nameEn || cat.name} {cat.nameBn ? `(${cat.nameBn})` : ''}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* ID Search */}
            <TextField
              variant="outlined"
              size="small"
              placeholder="Search by ID"
              value={idFilter}
              onChange={(e) => setIdFilter(e.target.value)}
              className={classes.filterField}
              InputProps={{
                style: { height: 40, fontSize: '0.85rem' },
              }}
            />
        </div>
        <Box display="flex" alignItems="center" flexWrap="wrap" style={{ gap: 12 }}>
          <Chip
            label={`Total Hadiths: ${totalCount}`}
            className={classes.countChip}
          />
          <Button
            variant="contained"
            startIcon={<CloudUploadIcon />}
            onClick={() => setSyncDialogOpen(true)}
            style={{
              background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
              color: '#ffffff',
              fontWeight: 600,
              borderRadius: 10,
              boxShadow: '0 4px 12px rgba(16,185,129,0.25)',
              textTransform: 'none',
              padding: '6px 16px',
            }}
          >
            iHadis Cloud Uploader
          </Button>
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={handleOpenCreateModal}
            disableElevation
            style={{ borderRadius: 10, textTransform: 'none', padding: '6px 16px' }}
          >
            Add New Hadith
          </Button>
        </Box>
      </div>

      {loading ? (
        <div className={classes.loadingContainer}>
          <CircularProgress size={40} thickness={4} />
          <Typography className={classes.loadingText}>Loading records...</Typography>
        </div>
      ) : (
        <TableContainer component={Paper} className={classes.tableContainer} elevation={0}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell width="60">Order</TableCell>
                <TableCell width="20%">Title</TableCell>
                <TableCell width="35%">Translation</TableCell>
                <TableCell width="12%">Book</TableCell>
                <TableCell width="12%">Source</TableCell>
                <TableCell width="90">Status</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items.map((item, idx) => {
                const titleEn = item.titleEn || item.title?.en || '';
                const titleBn = item.titleBn || item.title?.bn || '';
                const transEn = item.translationEn || item.english || item.translation?.en || '';
                const transBn = item.translationBn || item.bengali || item.translation?.bn || '';
                const bookName = item.sourceBn || getBookName(item.bookSlug || item.source);

                return (
                <TableRow key={item.id}>
                  <TableCell>
                    <span className={classes.orderBadge}>{item.order || item.orderIndex || idx + 1}</span>
                  </TableCell>
                  <TableCell>
                    {titleEn && (
                      <Typography variant="body2" color="textPrimary" style={{ fontWeight: 600, marginBottom: titleBn ? 4 : 0 }}>
                        {titleEn.length > 50 ? titleEn.substring(0, 50) + '...' : titleEn}
                      </Typography>
                    )}
                    {titleBn && (
                      <Typography variant="body2" color="textSecondary" style={{ fontSize: '0.8rem' }}>
                        {titleBn.length > 50 ? titleBn.substring(0, 50) + '...' : titleBn}
                      </Typography>
                    )}
                    {!titleEn && !titleBn && (
                      <Typography variant="body2" color="textSecondary" style={{ fontStyle: 'italic' }}>
                        {item.reference || `#${item.hadithNumber || 'Hadith'}`}
                      </Typography>
                    )}
                  </TableCell>
                  <TableCell>
                    {transBn && (
                      <Typography variant="body2" color="textPrimary" style={{ fontSize: '0.82rem', fontWeight: 500, marginBottom: transEn ? 4 : 0 }}>
                        {transBn.length > 80 ? transBn.substring(0, 80) + '...' : transBn}
                      </Typography>
                    )}
                    {transEn && (
                      <Typography variant="body2" color="textSecondary" style={{ fontSize: '0.76rem' }}>
                        {transEn.length > 70 ? transEn.substring(0, 70) + '...' : transEn}
                      </Typography>
                    )}
                    {!transEn && !transBn && (
                      <Typography variant="body2" color="textSecondary" style={{ fontStyle: 'italic' }}>No translation</Typography>
                    )}
                  </TableCell>
                  <TableCell>
                    <Chip
                      size="small"
                      label={bookName}
                      className={classes.categoryChip}
                    />
                  </TableCell>
                  <TableCell>
                    {item.sourceUrl ? (
                      <Chip
                        size="small"
                        icon={<OpenInNewIcon style={{ fontSize: 13 }} />}
                        label={item.sourceName || 'iHadis'}
                        component="a"
                        href={item.sourceUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        clickable
                        style={{
                          backgroundColor: 'rgba(16,185,129,0.1)',
                          color: '#059669',
                          fontWeight: 600,
                          fontSize: '0.72rem',
                          cursor: 'pointer',
                        }}
                      />
                    ) : (
                      <Typography variant="caption" color="textSecondary">
                        {item.sourceName || 'iHadis'}
                      </Typography>
                    )}
                  </TableCell>
                  <TableCell>
                    <Chip
                      size="small"
                      label={item.isPublished !== false ? 'Published' : 'Draft'}
                      className={item.isPublished !== false ? classes.statusPublished : classes.statusDraft}
                    />
                  </TableCell>
                  <TableCell align="right">
                    <Box display="flex" justifyContent="flex-end" style={{ gap: 6 }}>
                      <Tooltip title="Move Up">
                        <IconButton className={classes.actionBtn} onClick={() => handleReorder(item, 'up')}>
                          <ArrowUpwardIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Move Down">
                        <IconButton className={classes.actionBtn} onClick={() => handleReorder(item, 'down')}>
                          <ArrowDownwardIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Edit">
                        <IconButton className={classes.actionBtn} onClick={() => handleOpenEditModal(item.id)}>
                          <EditIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Delete">
                        <IconButton className={classes.deleteBtn} onClick={() => setDeleteTarget(item)}>
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </TableCell>
                </TableRow>
                );
              })}
              {items.length === 0 && (
                <TableRow>
                  <TableCell colSpan={6} align="center" style={{ padding: "48px 0" }} color="textSecondary">
                    <Typography variant="body1" color="textSecondary" style={{ fontWeight: 500 }}>
                      {idFilter ? `No hadith found with ID "${idFilter}"` : 'No records found for the selected criteria.'}
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {!loading && totalCount > 0 && (
        <Pagination
          page={page}
          totalPages={totalPages}
          totalCount={totalCount}
          pageSize={20}
          onPageChange={handlePageChange}
        />
      )}

      <ConfirmDialog
        open={!!deleteTarget}
        title="Delete Record"
        message="Are you sure you want to permanently remove this Hadith from the database? This action cannot be undone."
        confirmText="Delete"
        onConfirm={handleDelete}
        onCancel={() => setDeleteTarget(null)}
      />

      <HadithSyncDialog
        open={syncDialogOpen}
        onClose={() => setSyncDialogOpen(false)}
        onSyncComplete={() => loadData({ page: 1 })}
      />

      <HadithFormModal
        open={formModalOpen}
        hadithId={selectedHadithId}
        onClose={handleCloseFormModal}
        onSuccess={handleFormSuccess}
      />

      <Snackbar
        open={snackbar.open}
        message={snackbar.message}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
    </AdminLayout>
  );
}